import { all } from 'redux-saga/effects';

import {
    loadCallbackEnquiries
} from './sagas';

export default function* rootSaga() {
    yield all([
        loadCallbackEnquiries()
    ]);
}


// WEBPACK FOOTER //
// ./src/rootSaga.js